import * as React from "react";

import { BarcodeOutlined } from "@ant-design/icons";
import i18next from "i18next";

import Dropdown from "../Dropdown";
import { Nav } from "./styles";

const ProductMasterDataNavItem = ({
  isVisible,
  items,
}: {
  isVisible: boolean;
  items: any[];
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Nav.Item>
      <Dropdown
        icon={BarcodeOutlined}
        title={i18next.t("product_master_data")}
        items={items}
      />
    </Nav.Item>
  );
};

export default ProductMasterDataNavItem;
